import * as _ from "lodash";

import { Link } from "react-router-dom";
import React from "react";
import { NewButton } from "../../elements/ActionButtons/NewButton.jsx";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";

const SettingsTypeSelect = ({
  value,
  intl,
  history,
  role,
  path
}) => {

  // console.log("role=", role);
  let options = [];

  if (role === "ADMIN") {
    options =
      [
        {
          value: "COMPANY",
          label: intl.formatMessage({ id: "ids_company" })
        },
        {
          value: "DOCUMENT",
          label: intl.formatMessage({ id: "ids_document" })
        },
        {
          value: "PROJECTS",
          label: intl.formatMessage({ id: "ids_projects" })
        },
        {
          value: "CATEGORIES",
          label: intl.formatMessage({ id: "ids_categories" })
        },
        {
          value: "ARTICLES",
          label: intl.formatMessage({ id: "ids_articles" })
        },
        {
          value: "TAXES",
          label: intl.formatMessage({ id: "ids_taxes" })
        }
      ];
  }
  else if (role === "COMPTABLE") {
    options =
      [
        {
          value: "COMPANY",
          label: intl.formatMessage({ id: "ids_company" })
        },
        {
          value: "DOCUMENT",
          label: intl.formatMessage({ id: "ids_document" })
        },
        {
          value: "PROJECTS",
          label: intl.formatMessage({ id: "ids_projects" })
        },
        {
          value: "CATEGORIES",
          label: intl.formatMessage({ id: "ids_categories" })
        },
        {
          value: "ARTICLES",
          label: intl.formatMessage({ id: "ids_articles" })
        },
        {
          value: "TAXES",
          label: intl.formatMessage({ id: "ids_taxes" })
        }
      ];
  }
  else if (role === "COMMERCIAL") {
    options = [];
  }

  return (
    <div className="space-between full-width">
      <SimpleSelect
        name="settingsType"
        value={value}
        onSelected={choice => {
          if (choice.value !== value) {
            switch (choice.value) {
              case "COMPANY":
                history.push("/settings/company");
                break;

              case "DOCUMENT":
                history.push("/settings/documents");
                break;

              case "PROJECTS":
                history.push("/settings/projects");
                break;

              case "CATEGORIES":
                history.push("/settings/categories");
                break;

              case "ARTICLES":
                history.push("/settings/articles");
                break;

              case "TAXES":
                history.push("/settings/taxes");
                break;
            }
          }
        }}
        options={options}
        clearable={false}
        centered={true}
      />
    </div>
  );
};

export default SettingsTypeSelect;